module.exports = __webpack_public_path__ + "static/media/imagem11.eb5ecf7f.jpeg";